<template>
  <div class='breadcrumb'>
    <el-breadcrumb>
      <!-- <el-breadcrumb-item :to='{ path: '/home' }'>首页</el-breadcrumb-item>
      <el-breadcrumb-item><a href='/home/oj'>OJ管理</a></el-breadcrumb-item>
      <el-breadcrumb-item>{{ activePath }}</el-breadcrumb-item> -->
      <el-breadcrumb-item
        v-for='item in routeAarry'
        :key='item.path'
        :to='item.path'
        >{{ item.name }}</el-breadcrumb-item
      >
    </el-breadcrumb>
    <el-divider></el-divider>
  </div>
</template>

<script>
export default {
  name: 'com_breadcrumb',
  data() {
    return {
      routeAarry: [],
      arrs: []
    };
  },
  created() {
    this.initRouteAarry();   // 保持页面刷新 也能显示面包屑
  },
  watch: {
    $route: {
      immediate: true,  // 一旦检测到变化，立即执行
      handler() {
        this.routeAarry = JSON.parse(window.sessionStorage.getItem('path'));
        let pathArray = this.$route.matched;
        pathArray.forEach((value) => {
          // 提取数据
          let obj = { name: '', path: '' };
          obj.name = value.name;
          obj.path = value.path;
          this.arrs.push(obj);
        });
        window.sessionStorage.setItem('path', JSON.stringify(this.arrs));
        this.arrs = [];
        this.routeAarry = JSON.parse(window.sessionStorage.getItem('path'));
      }
      // {
      //   name:
      //   path
      // }
    }
  },

  methods: {
    initRouteAarry() {
      this.routeAarry = JSON.parse(window.sessionStorage.getItem('path'));
    }
  }
};
</script>

<style>
</style>
